import { render, staticRenderFns } from "./tvs.vue?vue&type=template&id=47ce631c&"
import script from "./tvs.vue?vue&type=script&lang=js&"
export * from "./tvs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports